<template>
  <b-link
    :link="link"
    :href="href"
    :rel="rel"
    :target="target"
    :active="active"
    :disabled="disabled"
    :to="to"
    :append="append"
    :replace="replace"
    :event="event"
    :active-class="activeClass"
    :exact="exact"
    :exact-active-class="exactActiveClass"
    :router-tag="routerTag"
    :prefetch="prefetch"
    :no-prefetch="noPrefetch"
    :router-component-name="routerComponentName"
    @click="$emit('click', $event)"
  >
    <slot>
      {{ link }}
    </slot>
  </b-link>
</template>

<script>
import { BLink } from 'bootstrap-vue';

export default {
  name: 'MLink',
  components: {
    BLink,
  },
  props: {
    link: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      default: null,
    },
    rel: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: '_self',
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    to: {
      type: [String, Object],
      default: null,
    },
    append: {
      type: Boolean,
      default: false,
    },
    replace: {
      type: Boolean,
      default: false,
    },
    event: {
      type: [String, Array],
      default: 'click',
    },
    activeClass: {
      type: String,
      default: null,
    },
    exact: {
      type: Boolean,
      default: false,
    },
    exactActiveClass: {
      type: String,
      default: null,
    },
    routerTag: {
      type: String,
      default: 'a',
    },
    prefetch: {
      type: Boolean,
      default: null,
    },
    noPrefetch: {
      type: Boolean,
      default: false,
    },
    routerComponentName: {
      type: String,
      default: null,
    },
  },
};
</script>
